// German translations for React Admin
// Based on ra-language-german but inline to avoid dependency issues

const germanMessages = {
    ra: {
        action: {
            add_filter: 'Filter hinzufügen',
            add: 'Hinzufügen',
            back: 'Zurück',
            bulk_actions: '%{smart_count} ausgewählt',
            cancel: 'Abbrechen',
            clear_array_input: 'Liste löschen',
            clear_input_value: 'Wert löschen',
            clone: 'Duplizieren',
            confirm: 'Bestätigen',
            create: 'Anlegen',
            create_item: '%{item} anlegen',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            export: 'Exportieren',
            list: 'Liste',
            refresh: 'Aktualisieren',
            remove_filter: 'Filter entfernen',
            remove_all_filters: 'Alle Filter entfernen',
            remove: 'Entfernen',
            save: 'Speichern',
            search: 'Suchen',
            select_all: 'Alle auswählen',
            select_row: 'Zeile auswählen',
            show: 'Anzeigen',
            sort: 'Sortieren',
            undo: 'Rückgängig',
            unselect: 'Abwählen',
            expand: 'Erweitern',
            close: 'Schließen',
            open_menu: 'Menü öffnen',
            close_menu: 'Menü schließen',
            update: 'Aktualisieren',
            move_up: 'Nach oben',
            move_down: 'Nach unten',
            open: 'Öffnen',
            toggle_theme: 'Theme umschalten',
            select_columns: 'Spalten',
            reset: 'Zurücksetzen',
            search_columns: 'Spalten durchsuchen',
            select_all_button: 'Alle auswählen',
            update_application: 'Anwendung neu laden',
        },
        boolean: {
            true: 'Ja',
            false: 'Nein',
            null: ' ',
        },
        page: {
            create: '%{name} anlegen',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Ein Fehler ist aufgetreten',
            list: '%{name}',
            loading: 'Lade',
            not_found: 'Nicht gefunden',
            show: '%{name} #%{id}',
            empty: 'Noch keine %{name}.',
            invite: 'Möchten Sie eine anlegen?',
        },
        input: {
            file: {
                upload_several:
                    'Dateien zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Datei zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            image: {
                upload_several:
                    'Bilder zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Bild zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            references: {
                all_missing: 'Die verknüpften Daten konnten nicht gefunden werden.',
                many_missing:
                    'Mindestens eine der verknüpften Daten ist nicht mehr verfügbar.',
                single_missing:
                    'Die verknüpften Daten sind nicht mehr verfügbar.',
            },
            password: {
                toggle_visible: 'Passwort verbergen',
                toggle_hidden: 'Passwort anzeigen',
            },
        },
        message: {
            about: 'Über',
            are_you_sure: 'Sind Sie sicher?',
            bulk_delete_content:
                'Sind Sie sicher, dass Sie %{name} löschen möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente löschen möchten?',
            bulk_delete_title:
                '%{name} löschen |||| %{smart_count} %{name} löschen',
            bulk_update_content:
                'Sind Sie sicher, dass Sie %{name} aktualisieren möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente aktualisieren möchten?',
            bulk_update_title:
                '%{name} aktualisieren |||| %{smart_count} %{name} aktualisieren',
            delete_content: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
            delete_title: '%{name} #%{id} löschen',
            details: 'Details',
            error:
                'Ein Fehler ist aufgetreten und Ihre Anfrage konnte nicht abgeschlossen werden.',
            invalid_form: 'Das Formular ist nicht korrekt. Bitte überprüfen Sie die Fehler',
            loading: 'Die Seite lädt, einen Moment bitte',
            no: 'Nein',
            not_found:
                'Sie haben eine falsche URL eingegeben oder einen fehlerhaften Link angeklickt.',
            yes: 'Ja',
            unsaved_changes:
                'Einige Ihrer Änderungen wurden nicht gespeichert. Sind Sie sicher, dass Sie diese ignorieren möchten?',
        },
        navigation: {
            no_results: 'Keine Ergebnisse gefunden',
            no_more_results:
                'Seite %{page} liegt außerhalb des Seitenbereichs. Versuchen Sie die vorherige Seite.',
            page_out_of_boundaries: 'Seite %{page} liegt außerhalb der Grenzen',
            page_out_from_end: 'Kann nicht über die letzte Seite hinausgehen',
            page_out_from_begin: 'Kann nicht vor Seite 1 gehen',
            page_range_info: '%{offsetBegin}-%{offsetEnd} von %{total}',
            partial_page_range_info:
                '%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}',
            current_page: 'Seite %{page}',
            page: 'Gehe zu Seite %{page}',
            first: 'Gehe zur ersten Seite',
            last: 'Gehe zur letzten Seite',
            next: 'Weiter',
            previous: 'Zurück',
            page_rows_per_page: 'Zeilen pro Seite:',
            skip_nav: 'Zum Inhalt springen',
        },
        sort: {
            sort_by: 'Sortieren nach %{field} %{order}',
            ASC: 'aufsteigend',
            DESC: 'absteigend',
        },
        auth: {
            auth_check_error: 'Bitte melden Sie sich an, um fortzufahren',
            user_menu: 'Profil',
            username: 'Benutzername',
            password: 'Passwort',
            sign_in: 'Anmelden',
            sign_in_error: 'Authentifizierung fehlgeschlagen, bitte erneut versuchen',
            logout: 'Abmelden',
        },
        notification: {
            updated:
                'Element erfolgreich aktualisiert |||| %{smart_count} Elemente erfolgreich aktualisiert',
            created: 'Element erfolgreich angelegt',
            deleted:
                'Element erfolgreich gelöscht |||| %{smart_count} Elemente erfolgreich gelöscht',
            bad_item: 'Fehlerhaftes Element',
            item_doesnt_exist: 'Element existiert nicht',
            http_error: 'Serverfehler',
            data_provider_error:
                'dataProvider Fehler. Prüfen Sie die Konsole für Details.',
            i18n_error:
                'Die Übersetzungen für die angegebene Sprache konnten nicht geladen werden',
            canceled: 'Aktion abgebrochen',
            logged_out: 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.',
        },
        validation: {
            required: 'Erforderlich',
            minLength: 'Mindestens %{min} Zeichen',
            maxLength: 'Maximal %{max} Zeichen',
            minValue: 'Mindestens %{min}',
            maxValue: 'Maximal %{max}',
            number: 'Muss eine Zahl sein',
            email: 'Muss eine gültige E-Mail-Adresse sein',
            oneOf: 'Muss einer der folgenden Werte sein: %{options}',
            regex: 'Muss dem Format entsprechen (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Gespeicherte Abfragen',
            query_name: 'Abfragename',
            new_label: 'Aktuelle Abfrage speichern...',
            new_dialog_title: 'Aktuelle Abfrage speichern als',
            remove_label: 'Gespeicherte Abfrage entfernen',
            remove_label_with_name: 'Abfrage "%{name}" entfernen',
            remove_dialog_title: 'Gespeicherte Abfrage entfernen?',
            remove_message: 'Sind Sie sicher, dass Sie diesen Eintrag aus Ihrer Liste der gespeicherten Abfragen entfernen möchten?',
            help: 'Filter die Liste und speichere diese Abfrage für später',
        },
        configurable: {
            customize: 'Anpassen',
            configureMode: 'Diese Seite konfigurieren',
            inspector: {
                title: 'Inspektor',
                content: 'Bewegen Sie den Mauszeiger über UI-Elemente, um sie zu konfigurieren',
                reset: 'Einstellungen zurücksetzen',
                hideAll: 'Alle ausblenden',
                showAll: 'Alle anzeigen',
            },
            Datagrid: {
                title: 'Datentabelle',
                unlabeled: 'Unbenannte Spalte #%{column}',
            },
            SimpleForm: {
                title: 'Formular',
                unlabeled: 'Unbenanntes Eingabefeld #%{input}',
            },
            SimpleList: {
                title: 'Liste',
                primaryText: 'Primärer Text',
                secondaryText: 'Sekundärer Text',
                tertiaryText: 'Tertiärer Text',
            },
        },
    },
};

export const de = {
    ...germanMessages,
    resources: {
        companies: {
            name: 'Unternehmen |||| Unternehmen',
            fields: {
                name: 'Name',
                alias: 'Unternehmensalias',
                aliasHelp: 'Optionaler Anzeigename. Ist er gesetzt, wird in der Anzeige überall der Alias statt des Firmennamens verwendet.',
                customerNumber: 'Kundennummer',
                customerNumberHelp: 'Eindeutige Kundennummer. Der Nummernkreis für azubi:web-Kunden beginnt bei 10000.',
                contactPerson: 'Ansprechpartner:in',
                email: 'E-Mail',
                phone: 'Telefon',
                street: 'Straße',
                addressSupplement1: 'Adresszusatz 1',
                addressSupplement2: 'Adresszusatz 2',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                billingEmail: 'E-Mail für Rechnungsversand',
                billingEmailHelp: 'An diese Adresse werden Rechnungen versendet. Leer = Standard-E-Mail des Unternehmens.',
                billingStreet: 'Rechnungsstraße',
                billingZip: 'Rechnungs-PLZ',
                billingCity: 'Rechnungsstadt',
                billingCountry: 'Rechnungsland',
                taxId: 'Steuernummer / USt-ID',
                commercialRegister: 'Handelsregisternummer',
                website: 'Webseite',
                active: 'Aktiv',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
                notes: 'Notizen',
                userCount: 'Anzahl User',
                courseCount: 'Anzahl Kurse',
                isDemoTenant: 'Demo-Mandant',
                isDemoTenantHelp: 'Demo-Mandanten werden vom täglichen Cleanup-Cron deaktiviert, sobald das Ablaufdatum erreicht ist.',
                expiresAt: 'Demo läuft ab',
                expiresAtHelp: 'Nur für Demo-Mandanten relevant. Leer = unbefristet.',
                publicRegistrationEnabled: 'Öffentliche Registrierung',
                publicRegistrationEnabledHelp: 'Erlaubt fremden Besuchern, sich über eine Landing Page selbst zu registrieren und dort Kurse zu kaufen. Ohne diese Freigabe bricht der Gast-Checkout mit einer Fehlermeldung ab.',
                parentCompany: 'Muttergesellschaft',
                parentCompanyHelp: 'Ordnet diesen Mandanten einer Unternehmensgruppe zu (z. B. Hotelkette). Mandanten derselben Gruppe sehen gruppeninterne Marktplatz-Angebote.',
                subsidiaries: 'Tochterunternehmen',
            },
            tabs: {
                general: 'Allgemein',
                address: 'Adresse',
                billing: 'Rechnungsadresse',
                legal: 'Rechtliche Informationen',
                metadata: 'Metadaten',
                demo: 'Demo',
                group: 'Unternehmensgruppe',
                licenses: 'Lizenzen',
            },
        },
        users: {
            name: 'Benutzer |||| Benutzer',
            fields: {
                email: 'E-Mail',
                emailLockedHelp: 'E-Mail-Adressen können nur von Superadmins geändert werden.',
                firstName: 'Vorname',
                lastName: 'Nachname',
                phone: 'Telefon',
                mobile: 'Mobil',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                dateOfBirth: 'Geburtsdatum',
                jobTitle: 'Position',
                department: 'Abteilung',
                language: 'Bevorzugte Sprache',
                company: 'Firma',
                roles: 'Rollen',
                userRoles: 'Rollen',
                password: 'Passwort',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                contact: 'Kontakt & Adresse',
                work: 'Arbeitsinformationen',
                personal: 'Persönlich',
                roles: 'Rollen & Berechtigungen',
            },
        },
        roles: {
            name: 'Rolle |||| Rollen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                permissions: 'Berechtigungen',
                application: 'Produkt',
            },
        },
        permissions: {
            name: 'Berechtigung |||| Berechtigungen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
            },
        },
        products: {
            name: 'Produkt |||| Produkte',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                price: 'Preis',
                application: 'Anwendung',
                active: 'Aktiv',
                permissions: 'Berechtigungen',
                currentPermissions: 'Aktuelle Berechtigungen',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                permissions: 'Berechtigungen',
                metadata: 'Metadaten',
            },
        },
        licenses: {
            name: 'Lizenz |||| Lizenzen',
            fields: {
                company: 'Firma',
                product: 'Produkt',
                startDate: 'Gültig ab',
                expiresAt: 'Gültig bis',
                expiresAtHelp: 'Leer lassen für unbefristete Lizenz',
                validFrom: 'Gültig ab',
                validUntil: 'Gültig bis',
                maxUsers: 'Max. Benutzer',
                active: 'Aktiv',
                status: 'Status',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                metadata: 'Metadaten',
            },
            status: {
                active: 'Aktiv',
                inactive: 'Inaktiv',
                expired: 'Abgelaufen',
                lifetime: 'Unbefristet',
            },
        },
        invitations: {
            name: 'Einladung |||| Einladungen',
            fields: {
                email: 'E-Mail',
                company: 'Firma',
                roles: 'Rollen',
                token: 'Token',
                createdAt: 'Erstellt am',
                expiresAt: 'Gültig bis',
                used: 'Verwendet',
                usedAt: 'Verwendet am',
                invitedBy: 'Eingeladen von',
                registeredUser: 'Registrierter Benutzer',
            },
        },
        'learning-groups': {
            name: 'Lerngruppe |||| Lerngruppen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                memberCount: 'Mitglieder',
                maxMembers: 'Max. Mitglieder',
                isPublic: 'Öffentlich',
                courseTitle: 'Kurs',
                createdAt: 'Erstellt am',
            },
            public: 'Öffentlich',
            private: 'Privat',
        },
        'peer-review-assignments': {
            name: 'Peer-Review |||| Peer-Reviews',
            fields: {
                lessonTitle: 'Lektion',
                submitterUserId: 'Einreicher',
                reviewerUserId: 'Reviewer',
                status: 'Status',
                submission: 'Abgabe',
                hasAttachment: 'Anhang vorhanden',
                attachmentFilename: 'Anhang',
                assignedAt: 'Zugewiesen am',
                completedAt: 'Abgeschlossen am',
            },
            status: {
                pending: 'Ausstehend',
                inReview: 'In Prüfung',
                completed: 'Abgeschlossen',
            },
        },
        learning_paths: {
            name: 'Lernpfad |||| Lernpfade',
            fields: {
                title: 'Titel',
                slug: 'URL-Slug',
                description: 'Beschreibung',
                thumbnailUrl: 'Vorschaubild URL',
                difficulty: 'Schwierigkeit',
                isActive: 'Aktiv',
                estimatedDuration: 'Geschätzte Dauer',
                courseCount: 'Kurse',
                enrollmentCount: 'Teilnehmer',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            difficulty: {
                beginner: 'Einstieg',
                intermediate: 'Vertiefung',
                advanced: 'Spezialisierung',
            },
            tabs: {
                details: 'Details',
                courses: 'Kurse',
                enrollments: 'Teilnehmer',
            },
            courses: {
                title: 'Kurse im Lernpfad',
                add: 'Kurse hinzufügen',
                remove: 'Kurs entfernen',
                empty: 'Noch keine Kurse in diesem Lernpfad.',
                required: 'Pflicht',
            },
            enrollments: {
                title: 'Einschreibungen',
                status: {
                    enrolled: 'Eingeschrieben',
                    in_progress: 'In Bearbeitung',
                    completed: 'Abgeschlossen',
                },
            },
        },
        learning_path_courses: {
            name: 'Lernpfad-Kurs |||| Lernpfad-Kurse',
        },
        learning_path_enrollments: {
            name: 'Lernpfad-Einschreibung |||| Lernpfad-Einschreibungen',
            fields: {
                userId: 'Benutzer ID',
                status: 'Status',
                progressPercentage: 'Fortschritt',
                enrolledAt: 'Eingeschrieben am',
                startedAt: 'Gestartet am',
                completedAt: 'Abgeschlossen am',
            },
        },
        learning_groups: {
            name: 'Lerngruppe |||| Lerngruppen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                courseTitle: 'Kurs',
                isPublic: 'Sichtbarkeit',
                createdAt: 'Erstellt am',
            },
        },
        peer_review_assignments: {
            name: 'Peer Review |||| Peer Reviews',
            fields: {
                reviewerName: 'Reviewer',
                submitterName: 'Einreicher',
                status: 'Status',
                assignedAt: 'Zugewiesen am',
                completedAt: 'Abgeschlossen am',
                courseName: 'Kurs',
                lessonTitle: 'Lektion',
            },
        },
    },
    custom: {
        changePassword: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        passwordChanged: 'Passwort erfolgreich geändert',
        language: 'Sprache',
        profile: {
            menuItem: 'Mein Profil',
            title: 'Mein Profil',
            notLoggedIn: 'Sie sind nicht angemeldet',
        },
    },
    admin: {
        dashboard: {
            welcome: 'Willkommen im Admin Dashboard',
            quickAccess: 'Schnellzugriff',
            stats: {
                companies: 'Unternehmen',
                users: 'Benutzer',
                invitations: 'Einladungen',
                roles: 'Rollen',
                products: 'Produkte',
                licenses: 'Lizenzen',
            },
            expiredLicenses: {
                title: 'Mandant ohne gültige Lizenz |||| Mandanten ohne gültige Lizenz',
                message: 'Ein Mandant hat keine gültige Lizenz — dort ist die Anmeldung gesperrt. |||| %{smart_count} Mandanten haben keine gültige Lizenz — dort ist die Anmeldung gesperrt.',
            },
            deletionRequests: {
                title: 'Löschanträge',
                requestedAt: 'Beantragt am %{requestedAt} · Entscheidung bis %{dueAt}',
                approve: 'Genehmigen',
                reject: 'Ablehnen',
                approveTitle: 'Konto löschen?',
                approveText: 'Das Konto von %{name} wird anonymisiert und gesperrt. Das lässt sich nicht rückgängig machen.',
                approveConfirm: 'Konto löschen',
                approved: 'Konto gelöscht.',
                rejectTitle: 'Löschantrag ablehnen',
                rejectReason: 'Begründung',
                rejectHelp: 'Die Begründung erhält die Person per E-Mail.',
                rejected: 'Antrag abgelehnt.',
                cancel: 'Abbrechen',
            },
            expiringLicenses: {
                title: 'Lizenz läuft bald ab |||| Lizenzen laufen bald ab',
                message: 'Eine Lizenz läuft in den nächsten 30 Tagen ab. |||| %{smart_count} Lizenzen laufen in den nächsten 30 Tagen ab.',
            },
            recentActivity: {
                title: 'Letzte Aktivitäten',
                subtitle: 'Überwachen Sie die neuesten Änderungen im System',
                activeUsers: 'aktive Benutzer',
                registeredCompanies: 'registrierte Unternehmen',
                issuedLicenses: 'ausgestellte Lizenzen',
            },
            systemOverview: {
                title: 'Systemübersicht',
                subtitle: 'Verwaltung von Berechtigungen und Zugriffen',
                definedRoles: 'Definierte Rollen',
                availableProducts: 'Verfügbare Produkte',
                openInvitations: 'Offene Einladungen',
                activeLicenses: 'Aktive Lizenzen',
                expiredLicensesWarning: 'Ein Mandant ohne gültige Lizenz |||| %{smart_count} Mandanten ohne gültige Lizenz',
                expiringLicensesWarning: 'Eine Lizenz läuft in 30 Tagen ab |||| %{smart_count} Lizenzen laufen in 30 Tagen ab',
            },
        },
        menu: {
            dashboard: 'Dashboard',
            companies: 'Unternehmen',
            users: 'Benutzer',
            invitations: 'Einladungen',
            roles: 'Rollen',
            permissions: 'Berechtigungen',
            products: 'Produkte',
            licenses: 'Lizenzen',
            learningGroups: 'Lerngruppen',
            peerReviews: 'Peer-Reviews',
            learningPaths: 'Lernpfade',
            analytics: 'Analytics & Reports',
            templates: 'Dokumentvorlagen',
            organizationSettings: 'Organisationseinstellungen',
            brandingSettings: 'Branding-Einstellungen',
            documents: 'Dokumente',
            legalDocuments: 'Rechtsdokumente',
            paymentSettings: 'Zahlungseinstellungen',
            orders: 'Bestellungen',
            landingPages: 'Landing Pages',
            marketplace: 'Marktplatz',
            licensedCourses: 'Lizenzierte Kurse',
            profile: 'Profil',
            changePassword: 'Passwort ändern',
            logout: 'Ausloggen',
            help: 'Hilfe',
            language: 'Sprache',
            loadingTranslations: 'Übersetzungen werden geladen...',
        },
        bottomNav: {
            dashboard: 'Dashboard',
            companies: 'Unternehmen',
            users: 'Benutzer',
            roles: 'Rollen',
            permissions: 'Rechte',
            products: 'Produkte',
            licenses: 'Lizenzen',
        },
    },
    companyOnboarding: {
        title: 'Neuen Mandanten anlegen',
        wizardButton: 'Mandant anlegen (Wizard)',
        steps: {
            company: 'Firma',
            domain: 'Domain',
            branding: 'Branding',
            license: 'Lizenz',
            admins: 'Administratoren',
            demoData: 'Demo-Daten',
            summary: 'Zusammenfassung',
            companyTitle: 'Unternehmensdaten',
            companyDescription: 'Grundlegende Informationen zum neuen Mandanten — und ob es sich um eine Demo handelt.',
            domainTitle: 'Domain',
            domainDescription: 'Auf welcher Domain soll der Mandant erreichbar sein?',
            brandingTitle: 'Branding',
            brandingDescription: 'Logo, Farben und Texte fürs Customer-Branding.',
            licenseTitle: 'Lizenz konfigurieren',
            licenseDescription: 'Wählen Sie das Produkt und konfigurieren Sie die Lizenz.',
            adminsTitle: 'Administratoren einladen',
            adminsDescription: 'Mindestens ein Administrator. Weitere Administratoren können beliebig hinzugefügt werden — alle bekommen eine Einladungs-Mail.',
            demoDataTitle: 'Demo-Daten kopieren',
            demoDataDescription: 'Wählen Sie einen Demo-Vorlage-Mandanten und welche Inhalte kopiert werden sollen.',
            summaryTitle: 'Zusammenfassung',
            summaryDescription: 'Überprüfen Sie alle Eingaben bevor Sie den Mandanten anlegen.',
        },
        fields: {
            companyName: 'Unternehmensname',
            companyEmail: 'E-Mail-Adresse',
            companyPhone: 'Telefon',
            companyWebsite: 'Webseite',
            isDemoTenant: 'Als Demo-Mandant anlegen',
            isDemoTenantHelp: 'Demo-Mandanten bekommen eine eigene .demo-Subdomain, ein konfigurierbares Ablaufdatum und Demo-Daten aus einer Vorlage.',
            domainModeSubdomain: 'Subdomain auf unserer Plattform-Domain',
            domainModeCustom: 'Eigene Domain (Customer bringt eigene Domain mit)',
            subdomainSlug: 'Subdomain',
            subdomainSlugHelp: 'Nur Buchstaben, Ziffern und Bindestriche, max. 40 Zeichen. Wird automatisch zertifiziert.',
            customDomain: 'Eigene Domain',
            customDomainCnameTitle: 'DNS-Eintrag beim Customer setzen',
            customDomainCnameHelp: 'Sobald der CNAME aktiv ist, holt unser TLS-Terminator beim ersten Request automatisch ein Cert.',
            domain: 'Domain',
            address: 'Adresse',
            logoUrl: 'Logo-URL',
            logoUrlHelp: 'Öffentlich erreichbare URL eines PNG/SVG.',
            primaryColor: 'Primärfarbe',
            secondaryColor: 'Sekundärfarbe',
            faviconUrl: 'Favicon-URL',
            appTitle: 'App-Titel',
            poweredByText: 'Footer-Text',
            street: 'Straße',
            zip: 'PLZ',
            city: 'Stadt',
            country: 'Land',
            product: 'Produkt',
            includedPermissions: 'Enthaltene Berechtigungen',
            more: 'weitere',
            hasExpiration: 'Lizenz mit Ablaufdatum',
            lifetimeLicenseInfo: 'Ohne Ablaufdatum wird eine unbefristete Lizenz erstellt.',
            licenseExpiresAt: 'Lizenz gültig bis',
            maxUsers: 'Max. User',
            adminEntry: 'Administrator %{index}',
            adminEmail: 'E-Mail-Adresse',
            adminFirstName: 'Vorname',
            adminLastName: 'Nachname',
            demoSourceCompany: 'Quell-Mandant',
            demoSourceCompanyHelp: 'Nur als Demo-Vorlage markierte Mandanten werden angeboten.',
            demoExpiresInDays: 'Demo läuft ab nach',
            demoExpiresInDaysHelp: 'Tage von heute. Mandant wird automatisch deaktiviert wenn das Datum erreicht ist.',
            demoSelectionTitle: 'Was kopieren?',
            demoSelection: {
                catalogs: 'Kurskataloge',
                courses: 'Kurse + Lektionen',
                learningPaths: 'Lernpfade',
                wiki: 'Wiki-Artikel',
                media: 'Medienbibliothek (mit Datei-Kopien)',
                h5p: 'H5P-Inhalte (mit Storage-Kopien)',
            },
        },
        units: {
            days: 'Tage',
        },
        sections: {
            address: 'Adresse',
        },
        buttons: {
            next: 'Weiter',
            back: 'Zurück',
            cancel: 'Abbrechen',
            finish: 'Mandant anlegen',
            addAdmin: 'Weiteren Administrator hinzufügen',
        },
        summary: {
            companySection: 'Unternehmen',
            domainSection: 'Domain',
            brandingSection: 'Branding',
            licenseSection: 'Lizenz',
            adminsSection: 'Administratoren',
            demoDataSection: 'Demo-Daten',
            unlimited: 'Unbegrenzt',
            adminInvitationNote: 'Alle Administratoren erhalten eine Einladungs-E-Mail mit Registrierungs-Link.',
            demoMode: 'Demo-Mandant',
            demoExpires: 'Wird nach %{days} Tagen automatisch deaktiviert.',
        },
        warnings: {
            demoMode: 'Demo-Modus aktiv: keine Lizenz nötig, eigene .demo-Subdomain, Auto-Cleanup nach Ablauf.',
            adminInvitation: 'Alle eingetragenen Administratoren erhalten eine Einladungs-E-Mail.',
            demoSeedDuration: 'Das Kopieren der Demo-Daten kann je nach Größe der Quelle einige Minuten dauern.',
            seedFailed: 'Mandant wurde angelegt, aber das Kopieren der Demo-Daten ist gescheitert.',
        },
        success: {
            production: 'Mandant erfolgreich angelegt — Administratoren wurden eingeladen.',
            withSeed: 'Demo-Mandant angelegt + Demo-Daten kopiert.',
        },
        errors: {
            companyNameRequired: 'Der Unternehmensname ist erforderlich.',
            subdomainRequired: 'Bitte eine Subdomain wählen.',
            subdomainInvalid: 'Ungültiges Subdomain-Format.',
            customDomainRequired: 'Bitte eine eigene Domain angeben.',
            productRequired: 'Bitte wählen Sie ein Produkt aus.',
            atLeastOneAdmin: 'Mindestens ein Administrator ist erforderlich.',
            adminEmailInvalid: 'Bitte eine gültige E-Mail-Adresse angeben.',
            demoSourceRequired: 'Bitte einen Demo-Quell-Mandanten auswählen.',
            demoExpiresRange: 'Bitte einen Wert zwischen 1 und 365 Tagen.',
            demoTemplatesLoad: 'Demo-Vorlagen konnten nicht geladen werden.',
            loadProductsFailed: 'Fehler beim Laden der Produkte.',
            unknown: 'Ein unbekannter Fehler ist aufgetreten.',
            network: 'Netzwerkfehler - bitte versuchen Sie es erneut.',
        },
    },
    registration: {
        title: 'Registrierung abschließen',
        company: 'Firma',
        email: 'E-Mail',
        assignedRoles: 'Zugewiesene Rollen',
        fields: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            password: 'Passwort',
            confirmPassword: 'Passwort bestätigen',
            passwordHelp: 'Mindestens 10 Zeichen',
            phone: 'Telefon',
            mobile: 'Mobil',
            street: 'Straße',
            zip: 'PLZ',
            city: 'Stadt',
            country: 'Land',
            jobTitle: 'Position',
            department: 'Abteilung',
            none: 'Keine',
        },
        buttons: {
            submit: 'Registrierung abschließen',
            goToLogin: 'Zur Anmeldung',
        },
        errors: {
            noToken: 'Kein Einladungs-Token angegeben.',
            invalidToken: 'Ungültige oder abgelaufene Einladung.',
            validationFailed: 'Einladung konnte nicht überprüft werden. Bitte versuchen Sie es erneut.',
            passwordMismatch: 'Die Passwörter stimmen nicht überein.',
            passwordTooShort: 'Das Passwort muss mindestens 10 Zeichen lang sein.',
            registrationFailed: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
            networkError: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        },
        success: {
            title: 'Registrierung erfolgreich!',
            message: 'Ihr Konto wurde erfolgreich erstellt. Sie werden zur Anmeldung weitergeleitet...',
        },
        error: {
            title: 'Registrierungsfehler',
        },
    },
    marketplace: {
        title: 'Marktplatz',
        browse: 'Marktplatz durchsuchen',
        myListings: 'Meine Angebote',
        myLicenses: 'Meine Lizenzen',
        mySales: 'Meine Verkäufe',
        noListings: 'Keine Kurse im Marktplatz verfügbar.',
        noLicenses: 'Sie haben noch keine Kurse lizenziert.',
        noSales: 'Sie haben noch keine Kurse verkauft.',
        noOwnListings: 'Sie haben noch keine Kurse im Marktplatz veröffentlicht.',
        licenseType: {
            reference: 'Referenz',
            copy: 'Kopie',
        },
        purchase: {
            title: 'Kurs lizenzieren',
            selectType: 'Lizenztyp wählen',
            referenceDescription: 'Live-Verknüpfung, Updates werden automatisch synchronisiert',
            copyDescription: 'Unabhängige Kopie, Sie können den Kurs anpassen',
            processing: 'Wird verarbeitet...',
            success: 'Lizenz erfolgreich erworben!',
            alreadyLicensed: 'Sie haben diesen Kurs bereits lizenziert.',
        },
        listing: {
            create: 'Kurs veröffentlichen',
            edit: 'Listing bearbeiten',
            selectCourse: 'Kurs auswählen',
            customTitle: 'Angezeigter Titel (optional)',
            customTitleHelp: 'Leer lassen für Kurstitel',
            priceReference: 'Preis Referenz-Lizenz',
            priceCopy: 'Preis Kopie-Lizenz',
            allowReference: 'Referenz-Lizenz erlauben',
            allowCopy: 'Kopie-Lizenz erlauben',
            revenueShare: 'Revenue Share (%)',
            revenueShareHelp: 'Ihr Anteil am Verkaufspreis',
            isActive: 'Aktiv (im Marktplatz sichtbar)',
            success: 'Kurs erfolgreich veröffentlicht!',
            updated: 'Listing aktualisiert!',
            deleted: 'Listing gelöscht!',
        },
        stats: {
            totalRevenue: 'Gesamtumsatz',
            licenses: 'Lizenzen',
            enrollments: 'Einschreibungen',
        },
    },
    profile: {
        avatar: {
            title: 'Profilbild',
            hint: 'JPG, PNG, GIF oder WebP. Max. 2 MB.',
            remove: 'Bild entfernen',
            uploadSuccess: 'Profilbild erfolgreich hochgeladen',
            uploadError: 'Fehler beim Hochladen des Profilbilds',
            deleteSuccess: 'Profilbild entfernt',
            deleteError: 'Fehler beim Entfernen des Profilbilds',
            invalidType: 'Ungültiges Dateiformat. Erlaubt: JPG, PNG, GIF, WebP',
            tooLarge: 'Datei zu groß. Maximal 2 MB.',
        },
    },
};
